import React from 'react';
import { IProps } from './type';

const TagIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.49 14.4125L14.4125 20.49C14.2425 20.66 14.0513 20.7875 13.8388 20.8725C13.6263 20.9575 13.4138 21 13.2013 21C12.9888 21 12.7763 20.9575 12.5638 20.8725C12.3513 20.7875 12.16 20.66 11.99 20.49L4.48875 12.9888C4.33292 12.8329 4.2125 12.6523 4.1275 12.4469C4.0425 12.2415 4 12.0254 4 11.7988V5.7C4 5.2325 4.16646 4.83229 4.49938 4.49938C4.83229 4.16646 5.2325 4 5.7 4H11.7988C12.0254 4 12.245 4.04604 12.4575 4.13813C12.67 4.23021 12.8542 4.35417 13.01 4.51L20.49 12.0113C20.66 12.1813 20.784 12.3725 20.8619 12.585C20.9398 12.7975 20.9788 13.01 20.9788 13.2225C20.9788 13.435 20.9398 13.644 20.8619 13.8494C20.784 14.0548 20.66 14.2425 20.49 14.4125ZM13.2013 19.3L19.2788 13.2225L11.7775 5.7H5.7V11.7775L13.2013 19.3ZM7.825 9.1C8.17917 9.1 8.48021 8.97604 8.72813 8.72813C8.97604 8.48021 9.1 8.17917 9.1 7.825C9.1 7.47083 8.97604 7.16979 8.72813 6.92188C8.48021 6.67396 8.17917 6.55 7.825 6.55C7.47083 6.55 7.16979 6.67396 6.92188 6.92188C6.67396 7.16979 6.55 7.47083 6.55 7.825C6.55 8.17917 6.67396 8.48021 6.92188 8.72813C7.16979 8.97604 7.47083 9.1 7.825 9.1Z"
        fill={fillColor ? fillColor : '#C4C6CC'}
      />
    </svg>
  );
};

export default TagIcon;
